/**
 * @fileoverview GHS-8AT外ケース取り付け時の注意点を記載したページです。
 */
import CoverAndFrontCapJa from "./img/CoverAndFrontCap.png";
import CoverAndFrontCapEn from "./img/English/coverAndFrontCapEn.png";
import CoverAndFrontCapKo from "./img/Korean/coverAndFrontCapKo.png";
import { useTranslation } from "react-i18next";

/**
 *
 * @returns {JSX.Element} GHS-8AT外ケース取り付け時の注意点を記載したページの JSX element
 */
export function Ghs8atCoverSetting(): JSX.Element {
  const { t, i18n } = useTranslation();

  //現在の言語に基づいて表示する画像を選択する
  const CoverAndFrontCap = () => {
    switch (i18n.language) {
      case "ja":
        return CoverAndFrontCapJa;
      case "ko":
        return CoverAndFrontCapKo;
      default:
        return CoverAndFrontCapEn;
    }
  };

  return (
    <>
      <h2 className="p-heading-2">{t("外ケース取り付け時の注意点")}</h2>
      <p className="c-text">
        {t(
          "外ケースを取り付けする際には，下図のように表示窓の向きが液晶画面に合うようにし外ケースの切欠きと測定器本体の凸部の位置を合わせ取り付けます。"
        )}
        {t(
          "カバーナットが斜めに入ってしまった場合は一度逆回りに戻し，再度締め直しを行ってください。"
        )}
      </p>
      <p className="c-text u-font-red">
        <b>
          {t(
            "カバーナットとフロントキャップの隙間がなくなるまで締めてください。"
          )}
          {t(
            "締めきらないと硫化水素ガスが本体内部に侵入して故障の原因になります。"
          )}
        </b>
      </p>
      <br />
      <img
        src={CoverAndFrontCap()}
        alt={t("カバーナットとフロントキャップの取り付け")}
        className="step-image"
      />
    </>
  );
}
